import axiosAuth from '../../axiosMain';

async function index() {
  let response = await axiosAuth.get('/certifications');
  return response.data.data;
}

async function store(data) {
  let form = new FormData();
  for (let key in data) {
    if (data[key] !== null) form.append(key, data[key]);
  }
  let response = await axiosAuth.post('/certifications', form);
  return response.data.data;
}

async function update(id, data) {
  let form = new FormData();
  for (let key in data) {
    if (data[key] !== null) form.append(key, data[key]);
  }
  let response = await axiosAuth.post('/certifications/' + id, form);
  return response.data.data;
}

async function destroy(id) {
  let response = await axiosAuth.delete('/certifications/' + id);
  return response.data.data;
}

export default {
  update,
  store,
  index,
  destroy,
};
